import { AnyAction } from "redux";
import { initialState } from "../store/initialState";
import { actionTypeKeys } from "../actions/actionTypeKeys";
import { AppointmentDto } from "../types/appointment";

export default function appointmentsReducer(
  state: AppointmentDto[] = initialState.appointments,
  action: AnyAction
): AppointmentDto[] {
  switch (action.type) {
    case actionTypeKeys.LOAD_APPOINTMENTS_SUCCESS:
      return action.appointments.map((a: AppointmentDto) => {
        return { ...a };
      });
    case actionTypeKeys.CANCEL_APPOINTMENT_SUCCESS:
      return [...state.filter(a => a.id < action.appointment.id), ...state.filter(a => a.id > action.appointment.id)];
    case actionTypeKeys.TRANSFER_APPOINTMENT_SUCCESS:
      return [
        ...state.filter(a => a.id < action.appointment.id),
        action.appointment,
        ...state.filter(a => a.id > action.appointment.id)
      ];
    default:
      return state;
  }
}
